import type { Step } from '../types/step';
import type { AppData } from '../../types/app_data';
import { StepCategory } from '../../types/app_data';

export const AddressStep: Step = {
  id: 'address',
  pathname: '/address',
  /**
   * If traffic is from partner and address data exists, skip it.
   */
  canShow: (appData: AppData) => !(appData.signupParams?.partnerSignup && appData.partnerSkippableData?.address),
  hasData: () => true,
  hasOwnData: (appData: AppData) => !!appData.address?.id,
  category: () => StepCategory.Account,
};
